<template>
  <nav class="menu-logado" style="line-height:1">
    <ul class="nav nav-fill align-items-center">
      <li class="nav-item order-1 order-md-1 nav-logo">
        <a class="navbar-brand" @click="redirectTo('/home')">
          <img :src="logoUrl" :alt="logo.texto" class="img-fluid img-logo" v-if="logoUrl">
          <img :src="logoDarkUrl" :alt="logo.texto" class="img-fluid img-logo-dark" v-if="logoDarkUrl">
          <template v-else>{{ logo.texto }}</template>
        </a>
      </li>
      <li v-if="exibirBarraBuscaHeader" class="nav-item search-menu order-2 order-md-2">
        <form>
          <div class="search">
            <input type="text" class="search-term" placeholder="O que você procura?" v-model="termoPesquisa">
            <button type="submit" class="searchButton" @click="buscaGeralPlataforma">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </form>
      </li>
      <li class="nav-item user-menu-notif order-5 order-md-5">
         <div>
        <b-dropdown class="search-menu-mobile" no-caret right>
          <template slot="button-content">
              <i class="fa fa-search"></i>
          </template>
          <form>
            <div class="search">
              <input type="text" class="search-term" placeholder="O que você procura?" v-model="termoPesquisa">
              <a type="submit" class="searchButton" @click="buscaGeralPlataforma">
                <i class="fa fa-search"></i>
              </a>
            </div>
          </form>
        </b-dropdown>
        </div>
        <slot></slot>
      <div class="user-menu order-2 order-md-7">
        <b-nav-item-dropdown no-caret class="menu-usuario-logado" right>
          <template slot="button-content">
            <a class="nav-link" href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img :src="avatar" @error="imgReplaceByDefault"></a>
          </template>
          <div class="d-flex nome-email align-items-center">
            <div>
              <p>{{ usuario.name }}</p>
              <p>{{ usuario.email }}</p>
            </div>
          </div>
          <hr />
          <b-dropdown-item v-if="temPermissaoAdmin && acessosEmpresa.temAcesso(tiposAcesso.SSO_PROFESSORES_JALEKO.nome, configEmpresa.rotasRestritasAcesso)" @click="redirectToWL()"><i class="fas fa-chalkboard-teacher"></i>Professores de Jaleko</b-dropdown-item>
          <b-dropdown-item @click="redirectTo('/perfil/meus-dados')"><i class="fas fa-user"></i> Meus dados</b-dropdown-item>
          <b-dropdown-item @click="redirectTo('/perfil/minhas-duvidas')" v-if="false"><i class="fas fa-hands-helping"></i> Minhas dúvidas</b-dropdown-item>
          <b-dropdown-item @click="redirectTo('/perfil/problemas')" v-if="false"><i class="fas fa-bug"></i> Problemas que relatei</b-dropdown-item>
          <b-dropdown-item @click="redirectTo('/perfil/cadernos')"><i class="fas fa-book"></i> Meus cadernos</b-dropdown-item>
          <b-dropdown-item @click="redirectTo('/perfil/meus-tutores')" v-if="acessosEmpresa.temAcesso(tiposAcesso.PERFIL_MEUS_TUTORES.nome, configEmpresa.rotasRestritasAcesso)"><i class="fas fa-chalkboard-teacher"></i> Tutor(a)</b-dropdown-item>
          <b-dropdown-item @click="redirectTo('/ajuda/faq')"><i class="fas fa-question-circle"></i> Ajuda</b-dropdown-item>
          <b-dropdown-item @click="redirectTo('/contato')"><i class="fas fa-comments"></i> Entre em contato</b-dropdown-item>
          <b-dropdown-item href="javascript:void(0)" @click="alternarDarkMode">
            <i class="fas fa-moon"></i>
            {{ modoNoturno ? "Sair do modo noturno" : "Modo noturno" }}
            <span class="aviso-novo">Novo</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="temPermissaoAdmin" @click="redirectToCms()"><i class="fas fa-user-cog"></i>Plataforma Admin</b-dropdown-item>
          <b-dropdown-item @click="logout()" class="link-logout"><i class="fas fa-sign-out-alt"></i> Sair</b-dropdown-item>
        </b-nav-item-dropdown>
      </div>
      </li>
    </ul>

    <ul class="nav nav2 nav-fill align-items-center" :style="{ 'background-color': menuBackgroundColor }">
      <li v-for="(link, i) in itens" :key="i" :class="classItem(link.cssClass)" :style="[!link.show ? {'display':'none'} : {}]">
        <template v-if="!i && link.show">
          <a class="nav-link desktop" href="javascript:void(0)" @click="exibeMenu()">
            <span>{{link.title}}</span> <i id="dropIcon" :class="exibeMenuCurso ? 'rotate-180-cw' : ''" class="fas fa-sort-down"></i>
          </a>
          <a class="nav-link mobile" @click="redirectTo('/cursos')">
            <span>{{link.title}}</span>
          </a>
        </template>
        <a class="nav-link" :href="link.href" :target="link.target" v-on="link.action ? { click: link.action } : {}" v-else-if="link.show">
          <span>{{ link.title }}</span>
          <span v-if="link.badge" v-html="link.badge" style="padding:0"></span>
        </a>
      </li>
    </ul>
    <menu-dropdown-cursos-b2b :categorias="categorias" :exibeMenuCurso="exibeMenuCurso" @ocultarMenu="ocultarMenu"></menu-dropdown-cursos-b2b>
  </nav>
</template>

<script>
import MenuDropdownCursosB2b from './menu-dropdown-cursos-b2b'
import './scss/vue-header-b2b.scss'

export default {
  name: 'HeaderB2b',
  components:{
    MenuDropdownCursosB2b
  },
  props: {
    categorias: Array,
    logo: Object,
    logoUrl: String,
    logoDarkUrl: String,
    acessosEmpresa: Object,
    tiposAcesso: Object,
    configEmpresa: Object,
    t: Function,
    router: Object,
    route: Object,
    exibirBarraBuscaHeader: Boolean,
    avatar: String,
    avatarPadrao: String,
    usuario: Object,
    temPermissaoAdmin: Boolean,
    modoNoturno: Boolean
  },
  data () {
    return {
      termoPesquisa: '',
      exibeMenuCurso: false,
      itens: [
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_CURSOS.nome, this.configEmpresa.rotasRestritasAcesso),
          title: this.t('cursos'),
          subLinks: this.categorias
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_JALEKLINICO.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Jaleklínico',
          href: '/jaleklinico',
          cssClass: 'order-2 order-md-2'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_FLASHCARDS.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Flashcards',
          href: '/flashcards',
          cssClass: 'order-4 order-md-4',
          badge: '<span class="aviso-novo">novo</span>'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_SIMULADOS.nome, this.configEmpresa.rotasRestritasAcesso),
          title: this.configEmpresa.textosConfiguraveis.textoDisplaySimulados,
          action: () => {
            this.redirectTo('/simulados')
          },
          cssClass: 'order-2 order-md-2'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_ARTIGOS.nome, this.configEmpresa.rotasRestritasAcesso),
          title: this.t('artigos'),
          href: 'https://blog.jaleko.com.br/',
          target: '_blank',
          cssClass: 'order-3 order-md-3'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_BIBLIOTECA_A.nome, this.configEmpresa.rotasRestritasAcesso),
          title: this.t('bibliotecaA'),
          action: () => this.SSOBibliotecaA(),
          cssClass: 'order-3 order-md-3'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_LIVES.nome, this.configEmpresa.rotasRestritasAcesso),
          title: this.configEmpresa.textosConfiguraveis.textoDisplayLives,
          action: () => this.redirectTo('/lives'),
          cssClass: 'order-4 order-md-4'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_FERRAMENTAS.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Ferramentas de Aprendizado',
          action: () => this.redirectTo('/ferramentas'),
          cssClass: 'order-4 order-md-4'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_ARTMED360.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Artmed360',
          action: () => this.redirectTo('/artmed360'),
          cssClass: 'order-4 order-md-4',
          badge: '<span class="aviso-novo">novo</span>'
        },
        {
          show: this.acessosEmpresa.temAcesso(this.tiposAcesso.HEADER_GRUPO_VITA_PART.nome, this.configEmpresa.rotasRestritasAcesso),
          title: 'Grupo Vita Part',
          href: 'https://vitapart.com.br/',
          target: '_blank',
          cssClass: 'order-3 order-md-3'
        }
      ],
      categoriaSelecionada: ''
    }
  },
  created () {
    this.menuBackgroundColor = this.configEmpresa.menuBackgroundColor ? this.configEmpresa.menuBackgroundColor : '#363953'
  },
  methods: {
    imgReplaceByDefault: function (event) {
      event.target.src = this.avatarPadrao
    },
    buscaGeralPlataforma: function (event) {
      event.preventDefault()

      this.$emit('buscaGeralPlataforma', this.termoPesquisa)
    },
    exibeMenu () {
      this.exibeMenuCurso = !this.exibeMenuCurso
    },
    ocultarMenu () {
      this.exibeMenuCurso = false
    },
    classItem: function (cssClass) {
      if (cssClass) {
        return 'nav-item ' + cssClass
      }
      return 'nav-item'
    },
    SSOBibliotecaA: function () {
      this.$emit('SSOBibliotecaA')
    },
    logout: function () {
      this.$emit('logout')
    },
    redirectToWL: function () {
      this.$emit('redirectToWL')
    },
    redirectToCms: function () {
      this.$emit('redirectToCms')
    },
    alternarDarkMode: function () {
      this.$emit('alternarDarkMode')
    },
    redirectTo: function (path) {
      if (this.router) {
        this.router.push(path);
      } else {
        window.location = path;
      }
    }
  }
}
</script>

<style lang="scss">

</style>